<tec-tile
    type="status"
    [title]="'LIFE_CHECK.PAGE_WARNING.HANDSETLANDSCAPE.TITLE' | translate"
    [subtitle]="'LIFE_CHECK.PAGE_WARNING.HANDSETLANDSCAPE.DESCRIPTION' | translate"
    icon="icon-alert"
/>
